// @ts-nocheck
/* eslint-disable */
export const niAngleRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17"><path d="M9 8.5L1.105 17 0 15.81 6.789 8.5 0 1.19 1.105 0z" transform="translate(-1207 -1359) translate(147 1179) translate(980 171) translate(80 9)" fill="#03B585" fill-rule="evenodd"/></svg>`,
    name: 'angle-right' as const
};